fx.ns("desktop.common.preview", class Preview extends fx.components.PopupPanel /*shared.preview.PreviewBase*/{
    
	constructor()
	{
		super();

		this.destroyOnSwitch = true;

        this.mode = "navigation";
	}

	// --------------------------- RENDER --------------------------- //

	create()
	{
		super.create();

		
		this.header = new fx.components.Box({className: "header"});
        this.addChild(this.header, {width : "100%", height : 63, top: 0, left : 0});

        this._optionSelectContainer = new fx.components.Box();
		this._optionSelect = new fx.components.LinkButton({icon : fx.get("assets").editIcon, iconPosition : "left", className : "cover-select"});
		this._optionSelect.toolTip = fx.text("Cliquez pour changer la taille ou la couverture");
		this._optionSelectContainer.addChild( this._optionSelect , {width : 330, height: 30, top : 0, left : 15});

		this.textBlock = new fx.components.VBox("textBlock");
		this.priceBlock = new fx.components.HBox();
		this.pageNumberBlock = new fx.components.HBox();
		this.text1 = new fx.components.Text({text : fx.text("Total"), className : "titleText"});
		this.text2 = new fx.components.Text({text : fx.text("(hors livraison) :"), className : "subtitleText"});
		this.text3 = new fx.components.Text({text : this.data.creation.totalPrice, className : "totalText"});
		//this.text4 = new fx.components.Text({text : ((this.data.creation.extraPages > 0) ? (this.data.creation.extraPages + " " + fx.text("supplémentaires") + " (+"+this.data.creation.pagesPrice.toFixed(2)+"€)" ) : (fx.text("Votre ouvrage contient")+this.data.creation.numberPages+ " " + fx.text("pages"))), className : "pageNumberText"});
		//this.text4 = new fx.components.Text({text : fx.text("Votre ouvrage contient") + " " + this.data.creation.numberPages + " " + fx.text("pages"), className : "pageNumberText"});
		this.priceBlock.addChild(this.text1);
		this.priceBlock.addChild(this.text2, {top: 0});
		this.priceBlock.addChild(this.text3);
		//this.pageNumberBlock.addChild(this.text4);
		this.orderButton = new fx.components.Button({className : "orderButton", label : fx.text("Commander")});
        this.orderButton.attr("data-testid", "preview-order");
		
		this.textBlock.addChild(this.priceBlock, { height : 22});
		this.textBlock.addChild(this.pageNumberBlock, { height : 20});

        this.header.addChild( this._optionSelectContainer, {width: 330, left: "center", height: 30} );
		this.header.addChild(this.textBlock, {right: 230, top: 20} );
		this.header.addChild(this.orderButton, {width: 200, right: 10, height: 30} );
		

        this.previewBook = new desktop.common.preview.BookPreview(this.data);
		this.previewBook.effect = "fade";
		this.addChild(this.previewBook, {width : "100%", bottom : 10, top :30, left : 0});
	}

	onDisplayUpdated()
	{
		super.onDisplayUpdated();
		
		//this._optionSelectContainer.viewport({ width : this.realWidth - this.header.realWidth - this.header.right(), height : 50, top : 0, left : "center"});
	}

	onReady()
	{
		super.onReady();

		//if (this.backContainer)
        //	this.on("click", this._onBack, this.backContainer);
	
		//this.on("order", this._onOrder, this.topBar);
		//this.on("click", this._onBack, this.exitContainer);
		this.on("click", this._onOrder, this.orderButton);
		this.on("options", this._onCoverOptions, this.previewBook);	
		//this.on("select", this._onClickArea, this.previewBoard);
		this.on("ready", this._onPhotoPlaced, this.data.creator);
		//this.on("click", this._onEdit, this.editButton);

		this.on("click", this._onInfoPanel, this._optionSelect);

		//this.on("edit", this._onEdit, this.viewWidget);
		//this.on("global-view", this._onView, this.viewWidget);
		//this.on("single-view", this._onView, this.viewWidget);
		
		//this._updateViewButton();

		// When creating book with IA, we create an empty book from the beggnining.
		// Book is set to deleted. So if user cancels process before to reach preview, 
		// he will not see his books in his account. But if he reaches preview, this book
		// will be then displayed in his account.
		this.data.creation.deleted = 0;

		this.listenUpdates(this.data.creation, true);

		this._updateCoverLabel();
	}

    // override
    onBackClick()
    {
        this.data.event("show-editor");
    }

	onChildUpdated(action)
	{
		this.onDataUpdated(action);
	}

	onDataUpdated(action)
	{
		if (action.type == "update" && action.model instanceof models.CreationElementContent && action.tag != "update-id" && action.tag != "fill" && !action.impactsOnly("id"))
			this.data.creator.bookUpdated = true;

       if (action.impacts("formatid") || action.impacts("cover_option"))
            this._updateCoverLabel();
	}

	onDataEvent(event)
	{
		if (event.type == "cover-updated")
		{
			this.previewBook.updatePage();
			this.data.creator.bookUpdated = true;
		}
		/*else 
		if(event.type == "apply-layout")
		{
			let area = this.previewBook.visible ? this.previewBook.area : (event.detail.area ? this.previewBoard.getAreaForPage(event.detail.area) : this.previewBoard.currentArea);

			if (area && !area.data.isCover)
			{
				let side = event.detail.side || (this.previewBook.visible ? this.previewBook.area.activePart : (this.previewBoard.currentArea ? this.previewBoard.currentArea.activePart : ""));
				area.applyLayout( event.detail.content, side );
			}
			event.cancel(); // so layout is not applied somewhere else
		}*/
	}

	/*_themeSelected(event)
	{
		if (!this._confirmationPopupDisplayed)
		{
			this._popup = new shared.popups.ConfirmUpdateTheme(event.detail);
			this.popup(this._popup);
			this.on("confirmed", this._onConfirmed, this._popup);

			this._confirmationPopupDisplayed = true;
		}
		else
			this._onConfirmed(event);

		
	}

	_onConfirmed(event)
	{
		if (this._popup)
			this.off("confirmed", this._onConfirmed, this._popup);

		// load new theme layouts
		this.data.creator.selectedTheme = event.detail.id;

		this._themeChanged = true;

		this.loading(true, "Mise à jour...");
		this.data.creator.placePhotos();
	}*/

	_onInfoPanel()
    {
        this.data.event("info-panel");
    }

	_onPhotoPlaced()
	{
		this.loading(false);
	}

	
	onOver(event)
    {
        this.previewBook.onOver(event);
    }

	onOut(event)
    {
        this.previewBook.onOut(event);
    }

	onSelect(event)
    {
		if (this.previewBook.visible)
			this.previewBook.onSelect(event);
    }

	/*_onUpdateMediaTab()
	{
		if (!this.previewBook.area.data.isCover && this.mediaTabs.visible) 
		{
			this.removeClass("focused");
			this.mediaTabs.hide();
			this.previewBook.viewport({width : this.mediaTabs.visible ? "fill" : "100%", left : this.mediaTabs.visible ? this.mediaTabs.width() : 0, height : "100%"});
		}
	}*/
	
	// --------------------------- ON ClICK EVENTS --------------------------- //

	close()
	{
		super.close()
	
		this.data.event("show-editor");
    }

	_onExit()
	{
		this.data.event("exit-editor");
	}

	_onOrder()
	{
		this.data.event("order-confirmed");
	}

	_onEdit()
	{
		this.data.event("show-editor");
	}

	_onCoverOptions()
	{
		this.data.event("select-cover");
		/*if (this.previewBook.area.data.isCover) // on cover ->close
		{
			this._onOptions()
		}
		else // to on cover and open media
		{
			this.previewBook.firstPage();		
			if (!this.mediaTabs.visible)
				this._onOptions();	
			else
				this.mediaTabs.mode = this.previewBook.area.data.isCover ? "cover" : "page";
		}*/
	}

	/*_onOptions()
	{
		if (!this.previewBook.area.data.isCover)
		{
			if (this.mediaTabs.visible)
			{
				this.removeClass("focused");
				this.mediaTabs.hide();
			}
		}
		else
		{
			this.toggleClass("focused");
			this.mediaTabs.mode = this.previewBook.area.data.isCover ? "cover" : "page";
			this.mediaTabs.toggle();
		}

		this.previewBook.viewport({width : this.mediaTabs.visible ? "fill" : "100%", left : this.mediaTabs.visible ? this.mediaTabs.width() : 0, height : "100%"});
	}*/

	/*_onView()
	{
		if (this._themeChanged && !this.previewBoard.visible)
			this.previewBoard.buildBook();

		this.previewBook.toggle();
		this.previewBoard.toggle();

		if (this.backText)
			this.backText.text = this.backLabel;

		//if (this.mediaTabs.visible)
		//	this.mediaTabs.hide();
		
		//this.previewBook.viewport({width :  "100%", left : 0, height : "100%"});
		//this.previewBoard.viewport({width : "100%", left : 0, height : "100%"});

		this.previewBoard.updateDisplay();

		this._updateViewButton();

		this.toggleClass("globalView", this.previewBoard.visible)
	}*/

	/*_updateViewButton()
	{
		if (this.previewBook.visible)
		{
			this.viewButton.icon = fx.assets.globalView;
			this.viewButton.label = fx.text("Vue Globale");
		}
		else
		{
			this.viewButton.icon = fx.assets.singleView;
			this.viewButton.label = fx.text("Vue Simple");
		}
	}*/

	_updateCoverLabel()
    {
        let currentCover = this.data.creation.covers.find({code : this.data.creation.cover_option});
        let format = this.data.creationFormat;
        
        this._optionSelect.label = fx.text("Album") + " " + format.description + ", " + currentCover.label;
    }


	destroy()
	{
		super.destroy();
		//this._mouse.destroy();
		//this.dragger.destroy();
		//this.viewWidget.destroy();
		this.previewBook.destroy();
		
		//this.mediaTabs.destroy();
		//this.previewBoard.destroy();
		//this.topBar.destroy();
		
		/*if (this.backContainer)
		{
			this.backContainer.destroy();
			this.backButton.destroy();
			this.backText.destroy();
		}*/
		
		//this.viewButton.destroy();
	}

});